import React from 'react'

export default function footer() {
  return (
    <div className='footer'>
        <span>Made with 🤍 by Shweta</span>
    </div>
  )
}
